import { bool, func } from 'prop-types';
import PaperComponent from './PaperComponent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from '../styles/MenuModal.module.css';

/**
 * @component MenuModal
 * @param { Object } props
 * @param { boolean } props.open
 * @param { function } props.onClose
 * @param { function } props.onSave
 * @returns { JSX.Element }
 */
function MenuModal({ open, onClose, onSave }) {
	return (
		<Dialog open={open} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle className={sty.dialog_title} id="draggable-dialog-title">
						Unsaved changes
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<DialogContentText>
							You are about to leave this content without saving. All changes will be lost. Do you
							really want to leave without saving?
						</DialogContentText>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button variant="outlined" size="small" onClick={onClose}>
					Leave without saving
				</Button>
				<Button variant="contained" size="small" onClick={onSave}>
					Save Changes
				</Button>
			</DialogActions>
		</Dialog>
	);
}

MenuModal.propTypes = {
	open: bool,
	onClose: func,
	onSave: func,
};

export default MenuModal;
